import { FieldControllerTypes } from '../../../components/form_v2/types';
import { afeIssueOptions, afeIssuePDFOptions, afeValidationOptions } from '../details/staticDetails';
import { AdtKindOptions } from '../users/selectOptions';

export const infoByAFMFields = [{
  control: FieldControllerTypes.input,
  type: 'search',
  name: 'afm',
  label: 'ΑΦΜ',
  filtersDesign: true,
  required: true,
  customLabel: true
}];

export const infoByNameFields = [
  [
    {
      control: FieldControllerTypes.input,
      type: 'search',
      name: 'surnameA',
      label: 'Επώνυμο',
      filtersDesign: true,
      required: true,
      customLabel: true
    },
    {
      control: FieldControllerTypes.input,
      type: 'search',
      name: 'nameA',
      label: 'Όνομα',
      filtersDesign: true,
      required: true,
      customLabel: true
    },
    {
      control: FieldControllerTypes.input,
      type: 'search',
      name: 'fathersFirstName',
      label: 'Πατρώνυμο',
      filtersDesign: true,
      required: true,
      customLabel: true
    }
  ]
];

export const infoByADTFields = [
  [
    {
      control: FieldControllerTypes.input,
      type: 'search',
      name: 'adt',
      label: 'ΑΔΤ',
      filtersDesign: true,
      required: true,
      customLabel: true
    },
    {
      control: FieldControllerTypes.select,
      name: 'kind',
      label: 'Είδος',
      filtersDesign: true,
      customLabel: true,
      options: AdtKindOptions
    }
  ]
];

export const confirmBankFields = [
  [
    {
      control: FieldControllerTypes.input,
      type: 'search',
      name: 'afm',
      label: 'ΑΦΜ',
      filtersDesign: true,
      required: true,
      customLabel: true
    },
    {
      control: FieldControllerTypes.input,
      type: 'search',
      name: 'iban',
      label: 'IBAN',
      filtersDesign: true,
      customLabel: true
    }
  ]
];

export const infoByAMKAFields = [{
  control: FieldControllerTypes.input,
  type: 'search',
  name: 'amka',
  label: 'AMKA',
  filtersDesign: true,
  required: true,
  customLabel: true
}];

export const amkaByInfoFields = [
  [
    {
      control: FieldControllerTypes.input,
      type: 'search',
      name: 'surname',
      label: 'Επώνυμο',
      filtersDesign: true,
      required: true,
      customLabel: true
    },
    {
      control: FieldControllerTypes.input,
      type: 'search',
      name: 'firstName',
      label: 'Όνομα',
      filtersDesign: true,
      required: true,
      customLabel: true
    },
    {
      control: FieldControllerTypes.input,
      type: 'search',
      name: 'afm',
      label: 'ΑΦΜ',
      required: true,
      filtersDesign: true,
      customLabel: true
    },
    {
      control: FieldControllerTypes.input,
      type: 'search',
      name: 'fatherName',
      label: 'Πατρώνυμο',
      filtersDesign: true,
      customLabel: true
    }
  ]
];

export const retrieveInfoByAFMFields = [{
  control: FieldControllerTypes.input,
  type: 'search',
  name: 'afm',
  label: 'ΑΦΜ',
  filtersDesign: true,
  required: true,
  customLabel: true
}];

export const retrieveParavolaInfoFields = [
  [{
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'afm',
    label: 'ΑΦΜ',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'number',
    name: 'foreasId',
    label: 'Κωδικός Φορέα',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'number',
    name: 'categoryId',
    label: 'Κωδικός Κατηγορίας',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.date,
    name: 'dateFrom',
    label: 'Ημερομηνία Από',
    filtersDesign: true,
    required: true,
  },
  {
    control: FieldControllerTypes.date,
    name: 'dateTo',
    label: 'Ημερομηνία Έως',
    filtersDesign: true,
    required: true,
  }]
];

export const categoriesInfoFields = [
  {
    control: FieldControllerTypes.input,
    type: 'number',
    name: 'foreasCode',
    label: 'Κωδικός φορέα',
    filtersDesign: true,
    required: true,
    customLabel: true
  }
];

export const typesInfoFields = [
  {
    control: FieldControllerTypes.input,
    type: 'number',
    name: 'categoryCode',
    label: 'Κωδικός Κατηγορίας',
    filtersDesign: true,
    required: true,
    customLabel: true
  }
];

export const userDetailsByAFMFields = [{
  control: FieldControllerTypes.input,
  type: 'search',
  name: 'afm',
  label: 'ΑΦΜ',
  filtersDesign: true,
  required: true,
  customLabel: true
}];

export const paravoloTypeFields = [{
  control: FieldControllerTypes.input,
  type: 'number',
  name: 'typeId',
  label: 'Κωδικός τύπου παραβόλου',
  filtersDesign: true,
  required: true,
  customLabel: true
}];

export const paravoloStatusFields = [{
  control: FieldControllerTypes.input,
  type: 'search',
  name: 'paravoloPaymentCode',
  label: 'Κωδικός πληρωμής παραβόλου (RF κωδικός) ή Κωδικός παραβόλου',
  filtersDesign: true,
  required: true,
  customLabel: true
}];

export const createParavoloShortFields = [
  [{
    control: FieldControllerTypes.input,
    type: 'number',
    name: 'typeCode',
    label: 'Κωδικός Τύπου Παραβόλου',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'number',
    name: 'paravoloAmount',
    label: 'Ποσό Παραβόλου',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'afm',
    label: 'ΑΦΜ',
    filtersDesign: true,
    required: true,
    customLabel: true
  }],
  [{
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'firstName',
    label: 'Όνομα',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'lastName',
    label: 'Επώνυμο',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'fatherName',
    label: 'Πατρώνυμο',
    filtersDesign: true,
    required: true,
    customLabel: true
  }]
];

export const createParavoloFields = [
  [{
    control: FieldControllerTypes.input,
    type: 'number',
    name: 'typeCode',
    label: 'Κωδικός Τύπου Παραβόλου',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'number',
    name: 'paravoloAmount',
    label: 'Ποσό Παραβόλου',
    filtersDesign: true,
    required: true,
    customLabel: true
  }],
  [{
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'afm',
    label: 'ΑΦΜ',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.date,
    type: 'search',
    name: 'birthDate',
    label: 'Ημερομηνία Γέννησης',
    filtersDesign: true,
    required: true,
  }],
  [{
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'firstName',
    label: 'Όνομα',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'lastName',
    label: 'Επώνυμο',
    filtersDesign: true,
    required: true,
    customLabel: true
  }],
  [{
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'fatherName',
    label: 'Πατρώνυμο',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'motherName',
    label: 'Μητρώνυμο',
    filtersDesign: true,
    required: true,
    customLabel: true
  }],
  [{
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'iban',
    label: 'Κωδικός IBAN',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'mobilePhone',
    label: 'Κινητό Τηλέφωνο',
    filtersDesign: true,
    required: true,
    customLabel: true
  }],
  [{
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'emailAddress',
    label: 'Διεύθυνση email',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.select,
    name: 'sendEmail',
    label: 'Αποστολή Email',
    filtersDesign: true,
    required: true,
    customLabel: true,
    options: [{ key: 'ΝΑΙ', value: 1 }, { key: 'ΟΧΙ', value: 0 }]
  }],
  [{
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'additionalInfo',
    label: 'Πρόσθετα Στοιχεία',
    filtersDesign: true,
    customLabel: true
  }]
];

export const GemiValidateAFMFields = [{
  control: FieldControllerTypes.input,
  type: 'search',
  name: 'afm',
  label: 'ΑΦΜ',
  filtersDesign: true,
  required: true,
  customLabel: true
}];

export const GemiValidateBranchFields = [
  [{
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'afm',
    label: 'ΑΦΜ',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'arGemi',
    label: 'Αριθμός ΓΕΜΗ',
    filtersDesign: true,
    required: true,
    customLabel: true
  }]
];

export const GemiBoardAFMFields = [{
  control: FieldControllerTypes.input,
  type: 'search',
  name: 'arGemi',
  label: 'Αριθμός ΓΕΜΗ',
  filtersDesign: true,
  required: true,
  customLabel: true
}];

export const GemiBoardV3Fields = [
  [{
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'arGemi',
    label: 'Αριθμός ΓΕΜΗ',
    filtersDesign: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'afm',
    label: 'ΑΦΜ',
    filtersDesign: true,
    customLabel: true
  }]
];

export const GemiBasicInfoFields = [{
  control: FieldControllerTypes.input,
  type: 'search',
  name: 'arGemi',
  label: 'Αριθμός ΓΕΜΗ',
  filtersDesign: true,
  required: true,
  customLabel: true
}];

export const GemiBasicInfoV3Fields = [
  [{
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'arGemi',
    label: 'Αριθμός ΓΕΜΗ',
    filtersDesign: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'afm',
    label: 'ΑΦΜ',
    filtersDesign: true,
    customLabel: true
  }]
];

export const afeValidationFields = [
  [{
    control: FieldControllerTypes.select,
    name: 'rvAfeType',
    label: 'Κωδικός του εκδότη του ΑΦΕ',
    filtersDesign: true,
    required: true,
    options: afeValidationOptions,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'rvAfeDoy',
    label: 'Κωδικός Δ.Ο.Υ.',
    filtersDesign: true,
    // required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'number',
    min: 0,
    name: 'rvAfeAa',
    label: 'Α/Α ή Αρ.Πρωτ. του ΑΦΕ.',
    filtersDesign: true,
    customLabel: true,
    required: true,
  }],
  [{
    control: FieldControllerTypes.input,
    type: 'number',
    name: 'rvAfeYear',
    label: 'Έτος έκδοσης του ΑΦΕ',
    filtersDesign: true,
    customLabel: true,
    required: true,
  },
  {
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'rvAfeAfm',
    label: 'Α.Φ.Μ. φορολογούμενου που αφορά το ΑΦΕ',
    filtersDesign: true,
    customLabel: true,
    required: true,
  }]

];
export const afeIssueFields = [
  [{
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'afeAfm',
    label: 'Α.Φ.Μ. φορολογούμενου',
    filtersDesign: true,
    required: true,
    customLabel: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'afeIssuedByAfm',
    label: 'Α.Φ.Μ. αιτούντα',
    filtersDesign: true,
    customLabel: true,
    disabled: true
  },
  {
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'afeEmployeeAfm',
    label: 'Α.Φ.Μ. υπαλλήλου που έχει κάνει το αίτημα',
    filtersDesign: true,
    customLabel: true,
    disabled: true
  }],
  [{
    control: FieldControllerTypes.input,
    minRows: 2,
    type: 'search',
    name: 'afeIssuedByDescr',
    label: 'Η περιγραφή του αιτούντα της έκδοσης του ΑΦΕ',
    filtersDesign: true,
    customLabel: true
  }],
  [{
    control: FieldControllerTypes.input,
    minRows: 2,
    type: 'search',
    name: 'afeIssuedByDescr2',
    label: 'Η περιγραφή της Υπηρεσίας που αιτείται την έκδοση',
    filtersDesign: true,
    customLabel: true,
  }],
  [{
    control: FieldControllerTypes.input,
    minRows: 2,
    type: 'search',
    name: 'afeIssuedByDescr3',
    label: 'Ταχυδρομική διεύθυνση της Υπηρεσίας που αιτείται την έκδοση',
    filtersDesign: true,
    customLabel: true
  }],
  [{
    control: FieldControllerTypes.select,
    type: 'search',
    name: 'afeReason',
    label: 'Λόγος για τον οποίο ζητείται ΑΦΕ',
    filtersDesign: true,
    customLabel: true,
    required: true,
    options: afeIssueOptions
  }],
  [{
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'afeText',
    label: 'Παρατηρήσεις - Μόνο για είσπραξη χρημάτων από φορείς του δημοσίου τομέα',
    filtersDesign: true,
    customLabel: true,
  }],
  [{
    control: FieldControllerTypes.input,
    type: 'search',
    name: 'afeForeas',
    label: 'Όνομα φορέα',
    filtersDesign: true,
    customLabel: true,
    required: true,
  },
  {
    control: FieldControllerTypes.select,
    type: 'search',
    name: 'afePdfRequested',
    label: 'Δημιουργία και εκτύπωση (PDF μορφή) του ΑΦΕ',
    filtersDesign: true,
    customLabel: true,
    required: true,
    options: afeIssuePDFOptions
  }]

];

export const aadeKadFields = [
  [
    {
      control: FieldControllerTypes.input,
      type: 'search',
      name: 'afm',
      label: 'ΑΦΜ',
      filtersDesign: true,
      required: true,
      customLabel: true
    },
    {
      control: FieldControllerTypes.date,
      name: 'dateFrom',
      label: 'Ημερομηνία από',
      filtersDesign: true,
      required: true
    },
    {
      control: FieldControllerTypes.date,
      name: 'dateTo',
      label: 'Ημερομηνία έως',
      filtersDesign: true,
      required: true,
    }
  ]
];

export const interoperabilityDashboardFields = (
  interoperabilities: { key: string, value: number }[], users: { key: string, value: number }[]
) => [
  [
    {
      control: FieldControllerTypes.autocomplete,
      name: 'interoperability_id',
      label: 'Διαλειτουργικότητα',
      filtersDesign: true,

      options: interoperabilities
    },
    {
      control: FieldControllerTypes.select,
      name: 'user_id',
      label: 'Χρήστες',
      filtersDesign: true,
      customLabel: true,
      options: users
    },
  ],
  [
    {
      control: FieldControllerTypes.date,
      name: 'dateFrom',
      label: 'Ημερομηνία από',
      filtersDesign: true,
    },
    {
      control: FieldControllerTypes.date,
      name: 'dateTo',
      label: 'Ημερομηνία έως',
      filtersDesign: true,
    }
  ]
];